<template>
  <van-sticky>
    <van-nav-bar
      v-if="show === true"
      :border="false"
      style="padding-bottom: 1vh;"
    >
      <template #title>
        <span>{{ title }}</span>
      </template>
      <template #left>
        <span @click="handleClickLeft">
          <van-icon v-if="left === 'prepage'" name="arrow-left" size="18" />
          <van-icon v-else name="" size="18" />
        </span>
      </template>
      <template #right>
        <span @click="handleClickRight">
          <van-icon v-if="right === 'create'" name="plus" size="18" />
          <van-icon v-else-if="right === 'warn'" name="question-o" size="18" />
          <van-icon v-else-if="right === 'more'" name="ellipsis" size="18" />
          <van-icon v-else-if="right === 'exit'" name="cross" size="18" />
          <van-icon v-else-if="right === 'refresh'" name="replay" size="18" />
          <van-icon v-else-if="right === 'shrink'" name="shrink" size="18" />
          <van-icon v-else-if="right === 'expand'" name="expand-o" size="18" />
          <van-icon v-else-if="right === 'share'" name="share-o" size="18" />
          <van-icon v-else-if="right === 'edit'" name="edit" size="18" />
          <van-icon v-else-if="right === 'save'" name="certificate" size="18" />
          <van-icon v-else-if="right === 'search'" name="search" size="18" />
          <van-icon v-else-if="right === 'scan'" name="scan" size="18" />
          <van-icon v-else name="" size="18" />
        </span>
      </template>
    </van-nav-bar>
  </van-sticky>
</template>

<script>
  
  export default {
    name: "Header",
    components: {
      
    },
		props: {
			show: { // 显示与否
				type: Boolean,
				default: true
			},
			title: { // 通过v-model绑定current值
				type: String,
				default: '科帕工业'
			},
			left: { // 激活时的演示，包括字体图标，提示文字等的演示
				type: String,
				default: ''
			},
			right: { // 未激活时的颜色
				type: String,
				default: ''
			},
			clickLeft: { // 左侧点击函数
				type: Function,
				default: null
			},
			clickRight: { // 右侧点击函数
				type: Function,
				default: null
			}
		},
    inject: ['reload'],
    data() {
      return {

      }
    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    computed: {

    },
    methods: {
      handleClickLeft() {
				if (typeof this.clickLeft === 'function') {
					// this.$router.go(-1)
          this.clickLeft.bind(this.$parent.handleClickLeft)()
          console.log(this.$parent)
				} else {
          console.log('左侧按钮')
				}
      },
      handleClickRight() {
				if (typeof this.clickRight === 'function') {
					this.clickRight.bind(this.$parent.handleClickRight)()
					console.log(this.$parent)
				} else {
          console.log('右侧按钮')
				}
      },
      handleClickCellExit() {

      }
    }
  }
</script>

<style scoped lang="scss">
  .van-nav-bar {
    height: 6.0vh;
    background-color: #0089ff;
  }
  ::v-deep .van-nav-bar__title {
    color: #FFF;
  }
  ::v-deep .van-nav-bar__text {
      color: #FFF;
  }
  ::v-deep .van-nav-bar .van-icon {
      color: #FFF;
  }
  ::v-deep .van-nav-bar__left {
    font-size: 28px;
  }
  ::v-deep .van-nav-bar__right {
    font-size: 28px;
  }
</style>
